import { useEffect } from 'react';
import { useLocation, useMatches, useParams } from 'react-router';
import { trackRumView } from '@/services/datadog';

export interface RouteHandle {
  rumView?: string;
}

export function pathTemplateFromMatch(
  pathname: string,
  params: Record<string, string | undefined>,
): string {
  if (!pathname) return '/';

  const paramByValue = new Map<string, string>();
  for (const [key, value] of Object.entries(params)) {
    if (typeof value === 'string' && value.length > 0 && !paramByValue.has(value)) {
      paramByValue.set(value, key);
    }
  }

  return pathname
    .split('/')
    .map((segment) => {
      const paramKey = paramByValue.get(segment);
      return paramKey ? `:${paramKey}` : segment;
    })
    .join('/');
}

export function useRumViewTracking() {
  const location = useLocation();
  const matches = useMatches();
  const params = useParams();

  useEffect(() => {
    const deepest = matches[matches.length - 1];
    const handle = deepest?.handle as RouteHandle | undefined;
    const name = handle?.rumView ?? pathTemplateFromMatch(location.pathname, params);
    trackRumView(name);
  }, [location.pathname, matches, params]);
}
